import { LINKS } from './constants'
import LoginButton from './LoginButton'
import MenuItem from './MenuItem'
import React, { useState } from 'react'
import SubscribeButton from './SubscribeButton'
import TagLogo from './TagLogo'
import styled from 'styled-components'
import { SubscribeModal } from '../SubscribeModal/SubscribeModal'
import { useHome } from '@site/contexts/homeContext'

const MenuWrapper = styled.ul`
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  width: 100%;
  height: 64px;
  background: white;
  box-shadow: 0 1px 4px rgb(19 26 45 / 20%);
  z-index: 99999;
  padding: 0 20px;
`

const MenuItems = styled.div`
  width:100%;
  max-width: 1172px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
`

const MenuGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const NavigationGroup = styled( MenuGroup )`
  width: 65%;
  min-width: 525px;
  justify-content: space-between;

  @media (min-width: 1165px) {
    & > a:first-child {
      margin-right: 80px;
      display: flex;
    }
  }
`

const DesktopMenu = () => {
  const [ showSubscribeModal, setShowSubscribeModal ] = useState( false )
  const { onClickSubscribe } = useHome()

  return (
    <MenuWrapper>
      <MenuItems data-testid="header-menu">
        <NavigationGroup>
          <TagLogo logoColor="blue" />
          { LINKS.map( ( { path, text, isExternal, icon } ) => (
            <MenuItem
              href={ path }
              icon={ icon }
              isExternal={ isExternal }
              key={ path }
              text={ text }
            />
          ) ) }
        </NavigationGroup>
        <MenuGroup>
          <LoginButton />
          <SubscribeButton onClick={ () => onClickSubscribe() } />
        </MenuGroup>
      </MenuItems>
    </MenuWrapper>
  )
}

export default DesktopMenu
